import { createContext, Ref } from "react";
import { GetFortuneRes, GetTelFortuneRes, SWRResponse } from "shared/types";

export type CvFromChatToSubscriptionPocContextValue = Partial<
  SWRResponse<GetFortuneRes | GetTelFortuneRes>
> & {
  isCvFromChatToSubscriptionPocEnabled?: boolean;
  intersection: boolean;
  intersectionRef: Ref<HTMLDivElement>;
};

export const cvFromChatToSubscriptionPocContext =
  createContext<CvFromChatToSubscriptionPocContextValue>({
    isCvFromChatToSubscriptionPocEnabled: false,
    intersection: false,
    intersectionRef: undefined,
  });
